import FormatResolver from "./formats/FormatResolver";
import $ from "jquery";

const formatResolver = new FormatResolver();

export const adFoxHandlers = () => {
    top.addEventListener('message', (event) => {
        try {
            const jsonData = JSON.parse(event.data);

            if (jsonData.formatName !== undefined) {

                if (jsonData.containerId === undefined) {
                    return;
                }

                const clsName = formatResolver.resolve(jsonData.formatName);
                const container = $(`#${jsonData.containerId}`);
                const parent = container.parents('.ad-content');
                jsonData.otherData.container = {width: parent.width(), height: parent.height()};

                const format = (new clsName(jsonData.otherData || {}));

                format.render(jsonData.action).then((html) => {
                    container.html(html);
                    format.callback();
                });
            }
        } catch (e) {
            console.log(`Error in top  addEventListener 'message'`, e.message, event.data);
        }
    })
}
